import {Resource} from '@raison/types';
import {selectAssets, selectCurrentCurrency} from '~/redux/assets/assetsSelectors';
import {Assets} from '~/shared/api/legacy_services/Assets/Assets';
import {createCurrencyService} from './CurrencyService';

export const selectAssetsResource = (state: AppModel): Resource<Assets> => {
    const {assets: currentData, error, fetching} = selectAssets(state);

    if (error) {
        return Resource.from({isError: true, error: error, data: currentData ?? undefined});
    }
    if (currentData) {
        return Resource.from({isSuccess: true, data: currentData, isFetching: fetching});
    }
    if (fetching) {
        return Resource.from({isLoading: true});
    }
    return Resource.from({isUninitialized: true});
};

export const selectTokenAccountsResource = (state: AppModel) =>
    selectAssetsResource(state).mapSuccess(({accounts}) => accounts.tokens);

export const selectCurrencyServiceResource = (state: AppModel) =>
    selectAssetsResource(state).mapSuccess(({currencies: rates}) =>
        createCurrencyService(rates, selectCurrentCurrency(state))
    );
